/* @flow */

import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { getIsFetching } from 'bucket/reducers/folders';
import * as FoldersActions from 'bucket/actions/folders';
import PageLoader from 'shared/components/PageLoader';
import IconHeader from 'shared/components/IconHeader';
import Folders from './Folders';
import Folder from './Folder';
import Upload from './Upload';

type Props = {
  isFetching: boolean,
  fetchFolders: () => void,
};

const mapStateToProps = state => ({
  isFetching: getIsFetching(state),
});

class App extends Component {
  props: Props;

  componentDidMount() {
    this.props.fetchFolders();
  }

  render() {
    const { isFetching } = this.props;

    if (isFetching) {
      return <PageLoader />;
    }

    return (
      <Router basename="/bucket">
        <div>
          <IconHeader
            icon="photo"
            circular
            title="Arborescence des ressources"
          />
          <div className="ui grid">
            <div className="twelve wide column">
              <Switch>
                <Route exact path="/" component={Folders} />
                <Route path="/folders/:id" component={Folder} />
              </Switch>
            </div>
            <div className="four wide column">
              <Upload />
            </div>
          </div>
        </div>
      </Router>
    );
  }
}

export default connect(mapStateToProps, {
  fetchFolders: FoldersActions.fetchFolders,
})(App);



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/App.js